const locales = {
  ru: {
    title_main: "Главная",
    title_contacts: "Контакты",
    title_map: "Карта",
    title_search: "Поиск по названию",
    main: "Главная",
    contacts: "Контакты",
    map: "На карте",
    my_orders: "Мои заказы",
    profile: "Профиль",
    logout: "Выйти",
    login: "Войти",
    search_rez: "Показаны результаты поиска первых 10 товаров",
  },
  ua: {
    title_main: "Головна",
    title_contacts: "Контакти",
    title_map: "Мапа",
    title_search: "Пошук по назві",
    main: "Головна",
    contacts: "Контакти",
    map: "На мапі",
    my_orders: "Мої замовлення",
    profile: "Профіль",
    logout: "Вийти",
    login: "Увійти",
    search_rez: "Показані результати пошуку перших 10 товарів",
  },
}

export default locales